import {useEffect, useState} from 'react'
import { useAuth } from '../context/AuthContext';
import { useParams, Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaArrowRight, FaArrowLeft, FaPhone } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import './AdminMainPage.css';




const IframeMainPage = () => {
   const { fetchAdminPublicBusiness, adminPublicData } = useAuth();
    const { businessId } = useParams();
    const [openBranch, setOpenBranch] = useState(false);
    const [openReservation, setOpenReservation] = useState(false);
    const [branchesId, setBranchesId] = useState(null);
    const [businessesId, setBusinessesId] = useState(null);
    const [filteredBusinesses, setFilteredBusinesses] = useState(null);



    const toggleOpenBranch = (branchId) => {
        setOpenBranch(true);
        setBranchesId(branchId);
        setOpenReservation(false); 
    }
    const toggleCloseBranch = () => {
        setOpenBranch(false);
        setBranchesId(null);
        setOpenReservation(false);
    }

    const toggleOpenReservation = (businessesId) => {
        setOpenBranch(false);
        setOpenReservation(true);
        setBusinessesId(businessesId);
    }

    const toggleCloseReservation = () => {
        setOpenReservation(false);
        setOpenBranch(true);
    }


    useEffect(() => { 
        if (businessesId && branchesId) {
            const filteredBranch = adminPublicData.branches?.find( branch => branch._id === branchesId)
            const filteredBusiness = filteredBranch?.businesses?.filter(business => business._id === businessesId);
            setFilteredBusinesses(filteredBusiness);
        }
    },[businessesId, adminPublicData, branchesId]);

    useEffect(() => {
        if (businessId) {
          fetchAdminPublicBusiness(businessId); 
          
        }
    }, [businessId, fetchAdminPublicBusiness]);


  return (
    <div className='min-height'>
        {!openReservation && !openBranch && <div className='adminmainpage-header'>
            <h2>Pobočky</h2>
            <p>Vyberte si pobočku a seznamte se s našimi službami</p>
        </div>}
       <div className='adminmainpage-branches-container'>
            {! openReservation && !openBranch && adminPublicData && adminPublicData.branches && adminPublicData.branches.length > 0 ? (<div>
                 
                <div className='adminmainpage-branches'>
                    {adminPublicData.branches.map((branch) => {
                    return <div className='adminmainpage-branch' key={branch._id} onClick={() => toggleOpenBranch(branch._id)}>
                        <div className='adminmainpage-icons'><FaMapMarkerAlt /><FaArrowRight className='adminmainpage-icon-arrow' /></div>
                        <h3>{branch.name}</h3>
                        <div className='adminmainpage-branch-details'>
                            <p className='adminmainpage-branch-city'>{branch.city}</p>
                            <p className='adminmainpage-branch-address'>{branch.street} {branch.houseNumber}, {branch.city} {branch.postalCode} {branch.country}</p>
                        </div>
                    </div>
                })}
                </div>
            </div>) : (
                openBranch ? (
                    <div />
                ) : (
                    openReservation ? (
                        <div />
                ) : (
                        <p>Žádné pobočky nebyly nalezeny.</p>                   
                )
                )
              )
            }
       </div>
       <div >
            {
            openBranch && <div>
                <button className="adminmainpage-back-button" onClick={() => toggleCloseBranch()}><FaArrowLeft size={13}/> Zpět na pobočky</button>
                { adminPublicData.branches && <div>
                    {
                        adminPublicData.branches.filter((branch) => {
                            return branch._id === branchesId;
                        }).map((branch) => {
                            return <div className='adminmainpage-header' key={branch._id}>
                                <h2>{branch.name}</h2>
                                <p className='adminmainpage-header-city'>{branch.city}</p>
                                <p className='adminmainpage-business-address'>{branch.street} {branch.houseNumber}, {branch.city} {branch.postalCode}, {branch.country}</p>
                                {branch.businesses && branch.businesses.length > 0 ? (
                                    <div className='adminmainpage-branch-details-container'>
                                    {branch.businesses.map((business) => {
                                        return <div className='adminmainpage-business' key={business._id}>              
                                            <h3>{business.owner && business.owner}</h3>
                                            <h4>{business.businessType && business.businessType}</h4>
                                            <p className='adminmainpage-branch-contact'><IoIosMail className='adminmainpage-branch-contact-icon' size={19} /> {business.email && business.email}</p>
                                            <p className='adminmainpage-branch-contact'><FaPhone className='adminmainpage-branch-contact-icon' size={12}/> {business.phone && business.phone}</p>
                                            <div className='adminmainpage-links'>
                                                <button onClick={() => toggleOpenReservation(business._id)}>Termíny</button>
                                            </div>
                                        </div>
                                    })
                                    }
                                    </div>
                                ) : (
                                    <p>Nenalezen žádný profil firmy pro tuto pobočku.</p>
                                )}
                                <div className='adminmainpage-footer'>
                                    <Link to="https://resanio.com">Powered by Resanio</Link>
                                </div>
                            </div>
                        })
                    }
                </div>
                }
            </div>
            }            
       </div>
       <div>
        {openReservation && <div>
           <button className="adminmainpage-back-button" onClick={() => toggleCloseReservation()}><FaArrowLeft size={13}/> Zpět na seznam</button>
           {
            filteredBusinesses?.map((business) => {
                return <div key={business._id}>
                    { business.basicReservation && <iframe scrolling='no' title="Reservation" style={{ width: '100%', height: '1200px', border: 'none' }} src={`/business/public/${business._id}/basicreservation/reservationform`}></iframe> }
                    { business.bookingReservation && <iframe scrolling='no' title="Reservation" style={{ width: '100%', height: '1200px', border: 'none' }} src={`/business/public/${business._id}/bookingreservation/reservationform`}></iframe> }
                    { business.lessonsReservation && <iframe scrolling='no' title="Reservation" style={{ width: '100%', height: '1200px', border: 'none' }} src={`/business/public/${business._id}/lessonsreservation/reservationform`}></iframe> }
                    { business.reservation && <iframe scrolling='no' title="Reservation" style={{ width: '100%', height: '1200px', border: 'none' }} src={`/business/public/${business._id}/reservationform`}></iframe> }
                     </div>
            })
           }
          </div>  
        }
       </div>
    </div>
  )
}

export default IframeMainPage